import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthenticationProvider } from "@cloudmlm/cloudmlm-auth";
import { ThemeProvider, CssBaseline, GlobalStyles } from "@mui/material";
import reportWebVitals from "./reportWebVitals";
import getTheme from "./theme-layouts/theme";
import { Provider } from "react-redux";
import store from "./redux/store";
import urlConstant from "./constants/urlConstants";
import ApiLoader from "./shared-components/apiLoader";

const Root = () => {
  const theme = getTheme("dark");
  const globalStyles = (
    <GlobalStyles
      styles={(theme) => ({
        html: {
          "--primary-main": theme.palette.primary.main,
          "--primary-darker": theme.palette.primary.darker,
          "--secondary-main": theme.palette.secondary.main,
          "--secondary-text": theme.palette.secondary.text,
          "--secondary-light": theme.palette.secondary.light,
          "--primary-darker": theme.palette.primary.darker,
          "--background-card": theme.palette.background.cardGradient,
          "--input-gradient": theme.palette.background.inputGradient,
          "--input-gradient-icon": theme.palette.background.inputGradientIcon,
          "--tree-gradient": theme.palette.background.treeGradient,
          "--black": theme.palette.common.black,
          "--body": theme.palette.common.page,
          "--white": theme.palette.common.white,
          "--green": theme.palette.common.green,
          "--red": theme.palette.common.red,
          "--headerbg": theme.palette.common.headerbg,
          "--error-bg": theme.palette.common.error,
          "--error-text": theme.palette.common.errortext,
          "--inputs": theme.palette.common.inputs,
        },
      })}
    />
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {globalStyles}
      <App />
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Suspense fallback={<ApiLoader />}>
      <AuthenticationProvider
        userInfoRoleEndpoint={urlConstant.RetailShopping.GetUserRoleByEmail}
      >
        <Root />
      </AuthenticationProvider>
    </Suspense>
  </Provider>
);

reportWebVitals();
